export default __webpack_public_path__ + "static/media/closeIcon.0fabd0b1.svg";